export default __webpack_public_path__ + "static/Icono-ahorro-en-energia-1b4901cd67714c11667db1e93ba65c58.png";